import { z } from "zod";

export const transactionWithoutMileageToUpdatePayloadSchema = z.object({
  data: z.array(
    z.object({
      transactionUuid: z.uuid(),
      vehicleUuid: z.uuid(),
      date: z.iso.datetime(),
    }),
  ),
});

export type TransactionWithoutMileageToUpdatePayload = z.infer<
  typeof transactionWithoutMileageToUpdatePayloadSchema
>;
